import { createContext, useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/universal/minimalism/themeContext.tsx
var STORAGE_KEY = "sworld-theme-mode";
var isThemeMode = (value) => value === "light" || value === "dark";
var readStoredMode = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isThemeMode(stored) ? stored : null;
  } catch (e) {
    return null;
  }
};
var writeStoredMode = (mode) => {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch (e) {
  }
};
var ThemeContext = createContext(void 0);
var GlassmorphismThemeContextProvider = (props) => {
  const { children, defaultMode = "light" } = props;
  const [mode, setMode] = useState(
    () => {
      var _a;
      return (_a = readStoredMode()) != null ? _a : defaultMode;
    }
  );
  useEffect(() => {
    writeStoredMode(mode);
  }, [mode]);
  const toggleTheme = useCallback(() => {
    setMode((prev) => prev === "light" ? "dark" : "light");
  }, []);
  const setTheme = useCallback((newMode) => {
    setMode(newMode);
  }, []);
  const value = useMemo(
    () => ({
      mode,
      toggleTheme,
      setTheme
    }),
    [mode, toggleTheme, setTheme]
  );
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value, children });
};
var useGlassmorphismTheme = () => {
  const context = useContext(ThemeContext);
  if (context === void 0) {
    throw new Error(
      "useGlassmorphismTheme must be used within a GlassmorphismThemeContextProvider"
    );
  }
  return context;
};

export { GlassmorphismThemeContextProvider, useGlassmorphismTheme };
//# sourceMappingURL=chunk-UIPXYAHD.mjs.map
//# sourceMappingURL=chunk-UIPXYAHD.mjs.map